module.exports = __webpack_public_path__ + "img/Cong_Tony_XU.c35d58dd.png";